import { ChakraBox as Box } from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";

export interface SpacerProps {
  hDesktop: string;
  hMobile: string;
  hTablet: string;
}

const Spacer = ({ hDesktop, hMobile, hTablet, sbEditable }: SbEditableComponentProps<SpacerProps>) => (
  <Box h={{ base: hMobile, md: hTablet, lg: hDesktop }} {...sbEditable} />
);

export default Spacer;
